var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dot-spinner--wrapper"},[_c('div',{class:_vm.spinnerClass},[_c('div',{staticClass:"double-bounce theme--bg"}),_c('div',{staticClass:"double-bounce double-bounce--delayed theme--bg"})])])}
var staticRenderFns = []

export { render, staticRenderFns }